window.debounce = window.debounce || function (fn, espera) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), espera || 300);
  };
};
window.throttle = window.throttle || function (fn, limite) {
  let esperando = false;
  return function (...args) {
    if (esperando) return;
    fn.apply(this, args);
    esperando = true;
    setTimeout(() => { esperando = false; }, limite || 200);
  };
};